import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  font-size: ${fontSize.s};
  width: fit-content;
  box-sizing: border-box;
  height: 35px;
  padding: 0px 10px;
  border: 1px solid ${colors.border};
  display: flex;
  align-items: center;
  cursor: pointer;
  transition-duration: 0.2s;
  border-radius: 2px;
  background-color: ${(props) =>
    props.selected ? colors.black : colors.backgroundSurfacePrimary};
  color: ${(props) =>
    props.selected ? colors.backgroundPrimary : colors.black};
  &:hover {
    border: 1px solid ${colors.black};
  }
`;
function OutlinedPicker({ text, selected, onClick }) {
  return (
    <Wrapper
      selected={selected}
      text={text}
      onClick={() => {
        onClick && onClick();
      }}
    >
      {text}
    </Wrapper>
  );
}

export default OutlinedPicker;
